export default {
	_formatData(value) {
			if (typeof value == "undefined" || value == null || value == "null" || value == "undefined") {
					return "";
			}
			return value;
	},
	_checkUserType() {
			return new Promise((resolve, reject) => {
					this.$http({
							method: "get",
							url: this.$urlMapper.getuser + "?" + new Date().getTime(),
							data: "noredirect"
					}).then((res) => {
							if (res.data.code == 10000) {
									resolve({
											type: '游客'
									});
							} else {
									if (res.data.type == 0) {
											resolve({
													type: '个人'
											});
									} else if (res.data.type == 1) {
											resolve({
													type: '法人'
											});
									} else {
											resolve({
													type: '游客'
											});
									}
							}
					});
			});
	},
	_isNullorEmpty(value) {
		if(typeof value == "undefined" || value == null || value == "" || JSON.stringify(value) == "{}" || JSON.stringify(value) == "[]") {
			return true;
		}
		return false;
	},
	_createUuid () {
		let d = new Date().getTime();
	    if (window.performance && typeof window.performance.now === "function") {
	        d += performance.now();
	    }
	    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        let r = (d + Math.random() * 16) % 16 | 0;
	        d = Math.floor(d / 16);
	        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	    });
	    return uuid;
	},
}


// WEBPACK FOOTER //
// ./yp/assets/js/Tools.js